import { Dispatch } from 'react';
import InstanceClient from '../../services/InstanceClient';
import StatusCode from '../../util/StatusCode';
import { Action, Reducer } from 'redux';
import { CoreOneRosterDashboard } from '../../models/CoreOneRosterModels';
import { RequestState } from '../../models/RequestState';


enum OneRosterDashboardActionType {
    DASHBOARD = 'ONEROSTER_DASHBOARD'
}

export interface OneRosterDashboardState {
    oneroster: RequestState<CoreOneRosterDashboard>
};

interface OneRosterDashboard_Get extends Action<OneRosterDashboardActionType> {
    type: OneRosterDashboardActionType.DASHBOARD
    oneroster: RequestState<CoreOneRosterDashboard>
}

export const getOneRosterInfo = () => (dispatch: Dispatch<OneRosterDashboard_Get>) => {
    const url = '/api/core/oneroster/dashboard'
    InstanceClient.get<CoreOneRosterDashboard>(url)
        .then(res => {
            dispatch({
                type: OneRosterDashboardActionType.DASHBOARD,
                oneroster: { code: StatusCode.COMPLETE, data: res.data }
            })
        })
        .catch(error =>
            dispatch({
                type: OneRosterDashboardActionType.DASHBOARD,
                oneroster: { code: StatusCode.ERROR, error }
            })
        )
}

type OneRosterDashboardAction = OneRosterDashboard_Get;

const initialState: OneRosterDashboardState = {
    oneroster: { code: StatusCode.PENDING }
}

export const reducer: Reducer<OneRosterDashboardState, OneRosterDashboardAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case OneRosterDashboardActionType.DASHBOARD:
            return {
                ...state,
                oneroster: action.oneroster
            }
        default:
            return state;
    }
}

